import "react-app-polyfill/ie11";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "./index.css";
import App from "./App";
import LoadingScreen from "./screens/Utils/LoadingScreen";
import ErrorScreen from "./screens/Utils/ErrorScreen";
import store from "./store";
import API from "./utils/API";
import { isLocalAPI } from "./utils/utils";

// TODO : Find better way to store these var in dap-front-library
window.fileRetrieveUrl = isLocalAPI
    ? "http://localhost:81/files/retrieve"
    : window.env.API_URL + "/dap-hcp-patient/api/v1/files/retrieve";
window.fileRetrieveHeaders = {
    client_id: window.env.API_CLIENT_ID,
    client_secret: window.env.API_CLIENT_SECRET,
    ApiKey: window.env.AUTH_API_KEY,
    Authorization: isLocalAPI ? localStorage.getItem("id_token") : "Bearer " + localStorage.getItem("access_token")
};

ReactDOM.render(<LoadingScreen />, document.getElementById("root"));

API.request({
    path: isLocalAPI ? "/constants" : "/dap-hcp-patient/api/v1/settings/constants"
})
    .then(constants => {
        window.CONSTANTS = constants;
        ReactDOM.render(
            <Provider store={store}>
                <App />
            </Provider>,
            document.getElementById("root")
        );
    })
    .catch(() => {
        ReactDOM.render(
            <ErrorScreen title="Erreur" content="Le service est indisponible, veuillez réessayer ultérieurement" />,
            document.getElementById("root")
        );
    });
